import { useEffect, useState } from "react";
import { FaPaperPlane } from "react-icons/fa6";
import { ModalWraper } from "../../../../../../../components/modal/wraper";
import { PopService } from "../../../../../../../services/PopService";
import { TextAreaDefault } from "../../../../../../../components/forms/TextAreaDefault";
import { InputDefault } from "../../../../../../../components/forms/InputDefault";
import { FaSave } from "react-icons/fa";
import { SelectNas } from "../../../../../../../components/forms/selects/SelectNas";
import { SelectPop } from "../../../../../../../components/forms/selects/SelectPop";
import { CentralOdcService } from "../../../../../../../services/CentralOdcService";
export const PopUpdateInfo = ({
  openModal,
  setOpenModal,
  data,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    pop_id: "",
    nas_id: "",
    olt_id: "",
    main_port: "",
    name: "",
    port: 1,
    description: "",
  });

  useEffect(() => {
    setFormData({
      pop_id: data.pop_id,
      nas_id: data.nas_id,
      olt_id: data.olt_id,
      main_port: data.main_port,
      name: data.name,
      port: data.port,
      description: data.description,
    });
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await CentralOdcService.updateInfo({ id: data?.id, data: formData });
      refreshData();
      setOpenModal(false);
      setFormData({
        pop_id: "",
        nas_id: "",
        olt_id: "",
        main_port: "",
        name: "",
        port: 1,
        description: "",
      });
    } catch (error) {
      alert("Gagal menyimpan data.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ModalWraper
      isOpen={openModal}
      setIsOpen={setOpenModal}
      title="Update info Central ODC"
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <SelectPop
          label="Pop"
          placeholder="Silahkan pilih Pop"
          nas_id={formData.nas_id}
          value={formData.pop_id}
          setValue={(selectedId) =>
            setFormData((prev) => ({ ...prev, pop_id: selectedId }))
          }
          searchable={true}
          disabled={formData.nas_id === ""}
        />

        <SelectNas
          label="Nas Server - MikroTik"
          placeholder="Silahkan pilih Nas Server"
          value={formData.nas_id}
          setValue={(selectedId) =>
            setFormData((prev) => ({ ...prev, nas_id: selectedId }))
          }
          searchable={true}
        />

        <InputDefault
          id="main_port"
          label="Port Utama"
          type="number"
          inputMode={"numeric"}
          placeholder="Masukan port utama..."
          value={formData.main_port}
          onChange={(e) => setFormData({ ...formData, main_port: e.target.value })}
        />
        <InputDefault
          id="name"
          label="Nama Central ODC"
          type="text"
          placeholder="Cth: Central ODC GADING"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <InputDefault
          id="port"
          label="Jumlah Port"
          type="number"
          inputMode={"numeric"}
          placeholder="Masukan jumlah port..."
          value={formData.port}
          onChange={(e) => setFormData({ ...formData, port: e.target.value })}
        />

        {/* Message */}
        <TextAreaDefault
          id="description"
          label="Deskripsi"
          placeholder="Masukan deskripsi atau keterangan..."
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
        />

        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => setOpenModal(false)}
            className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800"
          >
            Batal
          </button>

          <button
            type="submit"
            disabled={loading}
            className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
          >
            {loading ? (
              <>Menyimpan...</>
            ) : (
              <>
                <FaSave />
                Simpan
              </>
            )}
          </button>
        </div>
      </form>
    </ModalWraper>
  );
};
